import {
  Box,
  Button,
  FlexBox,
  Icon,
  ModalDialog,
  ModalDialogBody,
  ModalDialogButtons,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogNav,
  VisuallyHidden,
} from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { useLineItemData } from '../../contexts/LineItemDataContext';

interface ViewLargerImagesModalProps {
  isOpen: boolean;
  onZoomButtonClick: () => void;
  onDismiss: () => void;
  children: React.ReactNode;
}

/**
 * Responsible for rendering a magnifying glass icon which pops a "view larger" modal with the provided static image preview / PURCs preview component.
 * */
export const ViewLargerImagesModal = ({
  isOpen,
  onZoomButtonClick,
  onDismiss,
  children,
}: ViewLargerImagesModalProps) => {
  const [sharedActionMessages = {}] = useTranslations(['sharedActionMessages']);

  const { productName } = useLineItemData();

  return (
    <>
      {/* Zoom button */}
      <FlexBox alignItems="center" flexDirection="column">
        <Button skin="unstyled" onClick={onZoomButtonClick}>
          <Icon size="standard" iconType="zoomIn" alt="magnifying glass" />
          <VisuallyHidden>
            {sharedActionMessages.viewLarger}: {productName}
          </VisuallyHidden>
        </Button>
      </FlexBox>
      {/* Product image modal */}
      <ModalDialog
        isOpen={isOpen}
        onRequestDismiss={onDismiss}
        bodyWidth="capped"
        onlyRenderWhenOpen
        aria-label={productName || undefined}
      >
        <ModalDialogContent style={{ width: '600px' }}>
          <ModalDialogNav>
            <ModalDialogCloseButton
              accessibleText={sharedActionMessages.close}
            />
          </ModalDialogNav>
          <ModalDialogBody>
            <Box mt={5} px={6}>
              {children}
            </Box>
          </ModalDialogBody>
          <ModalDialogFooter>
            <ModalDialogButtons>
              <Button
                size="mini"
                width="full-width"
                skin="primary"
                onClick={onDismiss}
              >
                {sharedActionMessages.close}
              </Button>
            </ModalDialogButtons>
          </ModalDialogFooter>
        </ModalDialogContent>
      </ModalDialog>
    </>
  );
};
